<template>
  <layout>
    <div class="container-fluid full_height p-0">
      <div class="d-flex flex-column">
        <header class="head-schedule">
          <div class="search-schedule" />
          <div class="filter-schedule p-3" />
        </header>
        <div
          class="px-3 flex-grow-9 align-self-stretch flex justify-content-center items-center"
          style="height: 80vh;"
        >
          <div
            class="flex flex-column items-center  font-semibold font-montserrat"
          >
            <h1 class="font-32 text-blue">
              Щось пішло не так
            </h1>
            <p class="color_8d98ae font-24">
              Сторінку не знайдено
            </p>
            <img
              class="my-5"
              src="@/assets/images/404.svg"
              alt="img-404"
            >
            <a
              href="#"
              class="green-outline-btn"
              @click.prevent="back"
            >Повернутися назад</a>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/Layout'

export default {
  name: 'PageNotFound',
  components: {Layout},
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.search-schedule {
  height: 72px;
  background-color: #ffffff;
  border-bottom: 1px solid #ececec;
}
</style>
